module.exports = __webpack_public_path__ + "static/as_img_right-7e4c138a1da7f3bcd61f160394fe52c9.png";